import React from "react"
import { useTranslation } from "react-i18next"

export default function PPDematchingChainToggle({ linked, loading, onToggle }) {
    const [t] = useTranslation()

    return (
        <button
            type="button"
            className={
                "pp-dematching-chain" +
                (linked ? " pp-dematching-chain--linked" : " pp-dematching-chain--unlinked") +
                (loading ? " pp-dematching-chain--loading" : "")
            }
            onClick={onToggle}
            disabled={loading}
            title={linked ? t("dematching.chain_linked_hint") : t("dematching.chain_unlinked_hint")}
            aria-label={linked ? t("dematching.chain_linked_hint") : t("dematching.chain_unlinked_hint")}
        >
            <i
                className={"fas pp-dematching-chain__icon " + (linked ? "fa-link" : "fa-unlink")}
                aria-hidden="true"
            />
        </button>
    )
}
